import { render, staticRenderFns } from "./EntregaCreate.vue?vue&type=template&id=cf8e068e"
import script from "./EntregaCreate.vue?vue&type=script&lang=js"
export * from "./EntregaCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports